/* eslint-disable quotes */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";

import { useIntl } from "@edx/frontend-platform/i18n";
import {
  FormAutosuggestOption,
  FormControlFeedback,
} from "@openedx/paragon";
import AuthFormAutosuggest from "./AuthFormAutosuggest";
import classNames from "classnames";

import { FormGroup } from "../../common-components";
import { getPrimaryhSchool } from "../data/service";
import messages from "../messages";

const SchoolTeach = (props) => {
  const { formatMessage } = useIntl();

  const {
    onChangeHandler,
    selectedTown,
    selectedRegion,
    selectedSchoolTeach,
    roSelected,
    isTeacher,
    errorMessage,
    onFocusHandler,
  } = props;
  

  const [universities, setUniversities] = useState([]);
  useEffect(() => {
    const fetchSchools = async () => {
      if (roSelected) {
        const universityro = await getPrimaryhSchool(
          selectedRegion.selectionValue,
          selectedTown.selectionValue
        );
        setUniversities(universityro);
      }
      onChangeHandler({ target: { name: "school_teach", value: "" } });
    };
    fetchSchools();
  }, [selectedRegion, selectedTown, roSelected]);

  useEffect(() => {
        if (props.errorMessage === undefined){
          return
        }
        if (props.errorMessage !== "") {
          handleOnChange("");
        }
        
      }, [errorMessage]);
  

  const handleOnChange = (value) => {
    onChangeHandler({ target: { name: "school_teach", value: value } });
  };

  return (
    <div className="mb-4">
      {roSelected ? (
        <AuthFormAutosuggest
          floatingLabel={ `${formatMessage(messages["school_teacher_ro"])} *`}
          aria-label="form autosuggest"
          name="school_teach"
          value={selectedSchoolTeach}
          className={classNames({ "form-field-error": props.errorMessage })}
          onChange={(value) => handleOnChange(value)}
          onFocus={(e) => onFocusHandler(e)}
        >
          {roSelected
            ? universities.map((school) => (
              <FormAutosuggestOption key={school.id} id={school.id}>
                {school.name}
              </FormAutosuggestOption>
            ))
            : null}
        </AuthFormAutosuggest>
      ) : (
        <FormGroup
          name="school_teach"
          value={selectedSchoolTeach}
          handleChange={onChangeHandler}
          handleFocus={(e) => onFocusHandler(e)}
          helpText={[formatMessage(messages["school_teacher_intl"])]}
          floatingLabel={formatMessage(messages["school_teacher_intl"])}
        />
      )}
      {props.errorMessage !== "" && (
        <FormControlFeedback
          key="error"
          className="form-text-size"
          hasIcon={false}
          feedback-for="school_teach"
          type="invalid"
        >
          {props.errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

export default SchoolTeach;
